import React from 'react'
import { Col, Row } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <Navbar className='footer_bg'  data-bs-theme="light">
      <Container className='footer_container'>
        <Row className='footer_row'>
          <Row xl={12} >
            <Col xl={3} lg={3} md={4} sm={5} xs={5} >
              {/* <img className="footer-image" src="/images/icons/mission.png" alt='Load' /> */}
              <h2 className='brand'>IndiForms</h2>
            </Col>
            <Col xl={3} lg={3} md={4} sm={7} xs={7} >
              <ul className="footer-link" >
                <h3 className="footer-quick-link" >Quick Links</h3>
                <li className="footer-link-a"> <Link to="/">Home</Link> </li>
                <li className="footer-link-a"> <Link to="/feature"> Features </Link> </li>
                <li className="footer-link-a">  <Link to="/pricing"> Pricing</Link> </li>
              </ul>
            </Col>
            <Col className="footer-col-3" xl={3} lg={3} md={4} sm={7} xs={7} >
              <ul className="footer-link">
                <h3 className="footer-quick-link">Help</h3>
                {/* <li className="footer-link-a"> <Link to="/blogs">Blogs</Link> </li> */}
                <li className="footer-link-a"> <Link to="/form/example">Example Forms</Link> </li>
                <li className="footer-link-a"> <Link to="/support">Support</Link> </li>
              </ul>
            </Col>
            <Col className="footer-col-4" xl={3} lg={3} md={4} sm={5} xs={5} >
              <h3 className="footer-quick-link">Follow Us</h3>
              <div className="footer-icon-div" >
                <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer"> <img className="footer-icon" src="/images/icons/facebook.png" alt='Load' /> </a>
                <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer"> <img className="footer-icon" src="/images/icons/instagram.png" alt='Load' /> </a>
                <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer"> <img className="footer-icon" src="/images/icons/youtube.png" alt='Load' /> </a>
              </div>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col className="text-center footer_copyright" >
              <span> © 2024 Copyrights IndiForms - </span>
              <Link to="/terms/conditions" >Terms of Use</Link> -
              <Link to="/privacy/policy">Privacy Policy</Link> 
              {/* <Link to="/refund/policy">Refund & Cancellation Policy</Link> */}
            </Col>
          </Row>
        </Row>
      </Container>
    </Navbar>
  )
}

export default Footer